module.exports = __webpack_public_path__ + "img/554.454d5d18.jpg";